export default "__VITE_ASSET__BtozgfwB__"